module.exports = __webpack_public_path__ + "img/options-rectangle.079ff47c.svg";